// extracted by mini-css-extract-plugin
module.exports = {"selectableContentWrapper":"_selectableContentWrapper--2ZEl6"};